import { useEffect, useState } from "react";
import CookieConsentBanner from "@/components/CookieConsentBanner";
import CookieSettingsModal from "@/components/CookieSettingsModal";
import { OPEN_COOKIE_SETTINGS_EVENT, COOKIE_CONSENT_EVENT, readCookieConsent } from "@/lib/cookie-consent";

function applyAnalyticsConsent(analytics) {
  if (typeof window === "undefined") return;
  // PostHog: opt-in/out según consentimiento.
  if (window.posthog) {
    if (analytics) {
      window.posthog.opt_in_capturing();
    } else {
      window.posthog.opt_out_capturing();
    }
  }
  // Google Analytics 4 (Consent Mode v2): conceder/denegar el almacenamiento
  // de analítica. gtag se define en public/index.html con estado denegado.
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      analytics_storage: analytics ? "granted" : "denied",
    });
  }
}

export default function CookieConsentLayer() {
  const [settingsOpen, setSettingsOpen] = useState(false);

  useEffect(() => {
    // Aplicar preferencia ya guardada al montar
    const { analytics } = readCookieConsent();
    applyAnalyticsConsent(analytics);

    // Actualizar cuando el usuario cambia sus preferencias
    const handleConsentUpdate = () => {
      const { analytics: a } = readCookieConsent();
      applyAnalyticsConsent(a);
    };

    const handleOpenSettings = () => setSettingsOpen(true);

    window.addEventListener(COOKIE_CONSENT_EVENT, handleConsentUpdate);
    window.addEventListener(OPEN_COOKIE_SETTINGS_EVENT, handleOpenSettings);
    return () => {
      window.removeEventListener(COOKIE_CONSENT_EVENT, handleConsentUpdate);
      window.removeEventListener(OPEN_COOKIE_SETTINGS_EVENT, handleOpenSettings);
    };
  }, []);

  return (
    <>
      <CookieSettingsModal open={settingsOpen} onOpenChange={setSettingsOpen} />
      <CookieConsentBanner onOpenSettings={() => setSettingsOpen(true)} />
    </>
  );
}
